import React, { useState } from "react";
import Grid from '@material-ui/core/Grid';
import firebase from '../../firebase'
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import useStyles from '../themes/styles';
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";


const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setErrors] = useState("");
    const history = useHistory()
    const classes = useStyles()

    const handleForm = e => {

        e.preventDefault();
        firebase
            .auth()
            .signInWithEmailAndPassword(email, password)
            .then(res => {
                //   console.log(res)
                if (res.user) {
                    console.log(res.user.email);
                    setErrors(null)
                    history.push('/dashboard')
                }

            })
            .catch(e => {
                setErrors(e.message);
            });
    };

    return (
        <Grid container
            className={classes.root}
            spacing={2}
            direction="column"
            alignItems="center"
        >
            <Grid align='center' className={classes.input} item xs={6} sm={6} lg={12}>
                <FormControl required error={error} >
                    <InputLabel htmlFor="my-input">Email address</InputLabel>
                    <Input onChange={e => setEmail(e.target.value)} id="my-input" aria-describedby="my-helper-text" />
                </FormControl>
            </Grid>

            <Grid align='center' item xs={6} sm={6} lg={12}>
                <FormControl required error={error} >
                    <InputLabel htmlFor="my-input">Password</InputLabel>
                    <Input type="password" onChange={e => setPassword(e.target.value)} id="my-input" aria-describedby="my-helper-text" />
                </FormControl>
            </Grid>
            <Grid align='center' item xs={6} sm={6} lg={12}>

                <Button onClick={handleForm} variant="contained">Login</Button>

            </Grid>
            {error}
        </Grid>
    );
};

export default Login;